/* Carnis – forside v1.2 (v1.2, okt. 2026: kortene viser totalpris i valget, kilopris, sparing inkl. frakt,
   fraktlinje og pakkemodus for Carnis-pakken; v1.1: planer som betales og sendes hver 3./6./12. mnd legger alle krukkene for perioden i kurven)
   Kjøpsvelger i produktkortene (abonnement/engangskjøp), faner i pristabellen,
   knapper som velger abonnement og ruller til produktene, og klebrig knapp på mobil.
   Ingen avhengigheter. Bruker temaets <product-form> (product-form.js) for handlekurven. */
(function () {
  'use strict';
  if (window.CarnisForside) return;
  window.CarnisForside = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Tusenskille hentes fra butikkens money-format (moneySample i kortets config), så tallene fra Liquid
  // og tallene som oppdateres her ser like ut (1.096,50 kr).
  var MONEY_SEP = '.';
  function setMoneySample(sample) {
    var m = String(sample || '').match(/1(\D?)234(\D?)567/);
    if (m) MONEY_SEP = (m[1] === ' ' || m[1] === '') ? (m[1] === '' ? '' : ' ') : m[1];
  }
  function fmt(cents) {
    var v = Math.round(Number(cents) || 0);
    var kr = Math.floor(v / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, MONEY_SEP);
    var ore = ('0' + (v % 100)).slice(-2);
    return kr + ',' + ore + ' kr';
  }
  function fmtShort(cents) {
    var v = Math.round(Number(cents) || 0);
    if (v % 100 === 0) return Math.floor(v / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, MONEY_SEP) + ' kr';
    return fmt(v);
  }
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function setText(root, sel, txt) { qsa(root, sel).forEach(function (el) { el.textContent = txt; }); }
  function tpl(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] !== undefined ? map[k] : m; });
  }
  function scrollToEl(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  /* ---------------- Produktkort (v2, okt. 2026) ----------------
     Totalpris i valget og på knappen, pris per krukke (+ kilopris) under periodevalget, sparing inkl. frakt
     (mot å kjøpe én krukke i måneden) og felles fraktlinje over knappen. Pakkemodus (data-cfs-kind="pack"):
     månedsabonnement med fast månedspris og engangskjøp, begge med fri frakt. */
  function initCard(card) {
    if (card.dataset.cfsReady) return;
    card.dataset.cfsReady = '1';
    var cfg = {};
    try { cfg = JSON.parse((qs(card, '[data-cfs-config]') || {}).textContent || '{}'); } catch (e) { cfg = {}; }
    setMoneySample(cfg.moneySample);
    var t = cfg.text || {};
    var kind = cfg.kind || 'tiers';
    var pack = cfg.pack || {};
    var base = Number(cfg.base) || 0;
    var freeShip = Number(cfg.freeShip) || 0;
    var shipCost = Number(cfg.shipCost) || 0;
    var netWeight = Number(cfg.netWeight) || 0;
    var alwaysFree = !!cfg.alwaysFree;
    var jarsWord = t.jars || 'krukker';
    var jarWord = t.jar || 'krukke';

    var buy = qs(card, '[data-cfs-buy]');
    if (!buy) return;
    var form = qs(buy, 'form');
    var productForm = qs(buy, 'product-form');
    var inPlan = qs(buy, '[data-cfs-sp]');
    var inQty = qs(buy, '[data-cfs-qty]');
    var btn = qs(buy, '[data-cfs-atc]');
    var btnLabel = qs(buy, '[data-cfs-atc-label]');
    var modeInputs = qsa(buy, '[data-cfs-mode]');
    var tierInputs = qsa(buy, '[data-cfs-tier]');
    var opts = qsa(buy, '[data-cfs-opt]');
    var nudge = qs(buy, '[data-cfs-nudge]');
    var shipbar = qs(buy, '[data-cfs-shipbar]');

    var state = {
      mode: (qs(buy, '[data-cfs-mode]:checked') || {}).value || 'once',
      tier: qs(buy, '[data-cfs-tier]:checked')
    };
    if (!state.tier && tierInputs.length) {
      state.tier = tierInputs.filter(function (i) { return i.dataset.available === 'true'; })[0] || tierInputs[0];
      state.tier.checked = true;
    }
    if (state.mode === 'sub' && kind !== 'pack' && !tierInputs.length) state.mode = 'once';

    function shipFor(total) { return alwaysFree ? 0 : ((freeShip > 0 && total < freeShip) ? shipCost : 0); }
    function paintShipbar(total) {
      if (!shipbar) return;
      var txt = qs(shipbar, '[data-cfs-shipbar-text]');
      var fill = qs(shipbar, '[data-cfs-shipbar-fill]');
      var free = shipFor(total) === 0;
      var msg;
      if (free) {
        msg = kind === 'pack' ? (t.barFreePack || t.barFree || '') : (t.barFree || '');
      } else if (state.mode === 'sub') {
        var better = tierInputs.filter(function (i) { return Number(i.dataset.total) >= freeShip && (i.dataset.available === 'true' || cfg.designMode); })[0];
        msg = tpl(t.barLeftSub, { ship: fmtShort(shipCost), months: better ? better.dataset.months : '', left: fmtShort(freeShip - total) });
      } else {
        msg = tpl(t.barLeftOnce, { left: fmtShort(freeShip - total), ship: fmtShort(shipCost) });
      }
      if (txt) txt.textContent = msg;
      if (fill) fill.style.width = (free ? 100 : Math.max(4, Math.min(100, Math.round(total / freeShip * 100)))) + '%';
      shipbar.classList.toggle('is-free', free);
    }

    function render() {
      opts.forEach(function (o) { o.classList.toggle('is-active', o.getAttribute('data-cfs-opt') === state.mode); });
      modeInputs.forEach(function (i) { i.checked = i.value === state.mode; });
      tierInputs.forEach(function (i) {
        var l = i.closest('.cpdp-seg__item');
        if (l) l.classList.toggle('is-checked', i === state.tier);
        i.checked = i === state.tier;
      });

      var atc, fine, blocked = false, total = base, qtyMult = 1;

      if (state.mode === 'sub' && kind === 'pack') {
        total = Number(pack.price) || 0;
        atc = tpl(t.atcPackSub, { price: fmtShort(total) });
        fine = tpl(t.packTerms, { price: fmtShort(total), min: fmtShort(Number(pack.min) || total), months: pack.months });
        blocked = !pack.plan;
        if (inPlan) { inPlan.value = pack.plan || ''; inPlan.disabled = !pack.plan; }
      } else if (state.mode === 'sub' && state.tier) {
        var d = state.tier.dataset;
        var months = Number(d.months);
        var per = Number(d.per);
        total = Number(d.total);
        var list = base * months;
        var product = Math.max(0, list - total);
        var ship = Math.max(0, shipFor(base) * months - shipFor(total));
        var save = product + ship;
        blocked = d.available !== 'true';

        setText(buy, '[data-cfs-sub-total]', fmt(total));
        setText(buy, '[data-cfs-sub-compare]', list > total ? fmt(list) : '');
        var unitTxt = tpl(t.unitLine || '[jars] [unit] à [price]', { jars: months, unit: months === 1 ? jarWord : jarsWord, price: fmt(per) });
        if (netWeight > 0) unitTxt += tpl(t.kgPart || ' · [kg]/kg', { kg: fmt(per * 1000 / netWeight) });
        setText(buy, '[data-cfs-sub-unit]', unitTxt);
        setText(buy, '[data-cfs-sub-save]', tpl(t.subSave, { save: fmtShort(save), months: months, free: '' }) + (ship > 0 ? tpl(t.saveShipPart || '', { ship: fmtShort(ship) }) : ''));
        atc = tpl(t.atcSub, { total: fmt(total) });
        fine = tpl(shipFor(total) === 0 ? t.subTerms : (t.subTermsNoShip || t.subTerms), { months: months, total: fmt(total), jars: months });
        if (inPlan) { inPlan.value = d.plan || ''; inPlan.disabled = !d.plan; }
        // Betal og send hver periode (data-mult > 1): alle krukkene for perioden i kurven. Forhåndsbetalt: 1 (Shopify ganger opp selv).
        qtyMult = Number(d.mult) > 1 ? Number(d.mult) : 1;

        if (nudge) {
          var better = tierInputs.filter(function (i) {
            return Number(i.dataset.months) > months && (i.dataset.available === 'true' || cfg.designMode);
          })[0];
          if (better && t.nudge) {
            nudge.textContent = tpl(t.nudge, { months: better.dataset.months, pct: better.dataset.pct, price: fmt(Number(better.dataset.per)) });
            nudge.hidden = false;
            nudge.dataset.target = better.value;
          } else {
            nudge.hidden = true;
          }
        }
      } else {
        total = base;
        atc = tpl(t.atcOnce, { total: fmt(base) });
        fine = kind === 'pack' ? (t.packOnceTerms || '') : (t.onceFine || '');
        if (inPlan) { inPlan.value = ''; inPlan.disabled = true; }
      }
      if (inQty) inQty.value = qtyMult;
      paintShipbar(total);

      setText(buy, '[data-cfs-fine]', fine);
      if (btnLabel && btn && !btn.disabled) btnLabel.textContent = atc;
      if (btn) btn.toggleAttribute('data-cfs-blocked', blocked);
    }

    modeInputs.forEach(function (i) {
      i.addEventListener('change', function () { if (i.checked) { state.mode = i.value; render(); } });
    });
    tierInputs.forEach(function (i) {
      i.addEventListener('change', function () { if (i.checked) { state.tier = i; state.mode = 'sub'; render(); } });
    });
    if (nudge) nudge.addEventListener('click', function () {
      var target = tierInputs.filter(function (i) { return i.value === nudge.dataset.target; })[0];
      if (target) { state.tier = target; state.mode = 'sub'; render(); }
    });

    // Før temaets product-form sender skjemaet: fjern app-injiserte selling_plan-felt og stopp planer som ikke er aktive
    if (productForm && form) {
      productForm.addEventListener('submit', function (e) {
        if (btn && btn.hasAttribute('data-cfs-blocked')) {
          e.preventDefault(); e.stopImmediatePropagation();
          return;
        }
        qsa(form, '[name="selling_plan"]').forEach(function (el) { if (el !== inPlan) el.parentNode.removeChild(el); });
        if (inPlan) inPlan.disabled = !(state.mode === 'sub' && inPlan.value);
      }, true);
    }

    card.cfsChoose = function (mode, months) {
      if (mode === 'sub' && (tierInputs.length || kind === 'pack')) {
        state.mode = 'sub';
        if (months) {
          var ti = tierInputs.filter(function (i) { return i.value === String(months); })[0];
          if (ti) state.tier = ti;
        }
      } else if (mode === 'once') {
        state.mode = 'once';
      }
      render();
    };

    render();
  }

  /* ---------------- Knapper som velger og ruller ----------------
     data-cfs-choose="sub" | "sub:6" | "sub:6:storfetalg" | "once" | "once::carnis-organmix" */
  function onChoose(e) {
    var a = e.target.closest ? e.target.closest('[data-cfs-choose]') : null;
    if (!a) return;
    var parts = (a.getAttribute('data-cfs-choose') || '').split(':');
    var mode = parts[0];
    var months = parts[1];
    var handle = parts[2];
    var cards = qsa(document, '[data-cfs-card]');
    if (!cards.length) return; // ingen produktkort på siden – la lenken fungere som vanlig
    var targets = handle ? cards.filter(function (c) { return c.dataset.handle === handle; }) : cards;
    if (!targets.length) targets = cards;
    targets.forEach(function (c) { if (c.cfsChoose) c.cfsChoose(mode, months); });
    var dest = handle ? targets[0] : (qs(document, '[data-cfs-shop]') || targets[0]);
    e.preventDefault();
    scrollToEl(dest);
  }

  /* ---------------- Faner i pristabellen ---------------- */
  function initTabs(root) {
    if (root.dataset.cfsReady) return;
    root.dataset.cfsReady = '1';
    var tabs = qsa(root, '[data-cfs-tab]');
    var panels = qsa(root, '[data-cfs-panel]');
    var cta = qs(root, '[data-cfs-subx-cta]');
    if (!tabs.length) return;
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) { p.hidden = p.dataset.handle !== tab.dataset.handle; });
      if (cta) {
        var parts = (cta.getAttribute('data-cfs-choose') || 'sub:6:').split(':');
        cta.setAttribute('data-cfs-choose', parts[0] + ':' + parts[1] + ':' + tab.dataset.handle);
      }
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, n) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var i = null;
        if (e.key === 'ArrowRight') i = (n + 1) % tabs.length;
        if (e.key === 'ArrowLeft') i = (n - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') i = 0;
        if (e.key === 'End') i = tabs.length - 1;
        if (i !== null) { e.preventDefault(); select(tabs[i], true); }
      });
    });
  }

  /* ---------------- Klebrig knapp på mobil ----------------
     Vises når toppknappen er scrollet forbi, skjules når produktkortene eller bunnen er synlige. */
  function initSticky() {
    var bar = qs(document, '[data-cfs-sticky]');
    if (!bar || bar.dataset.cfsReady || !('IntersectionObserver' in window)) return;
    bar.dataset.cfsReady = '1';
    var trigger = qs(document, '[data-cfs-hero-actions]');
    var shop = qs(document, '[data-cfs-shop]');
    var footer = document.querySelector('footer, .footer, [id*="footer"]');
    var seen = { pastHero: false, shop: false, footer: false };
    var link = qs(bar, 'a');
    function update() {
      var show = seen.pastHero && !seen.shop && !seen.footer;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (link) link.tabIndex = show ? 0 : -1;
    }
    if (trigger) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen.pastHero = !en.isIntersecting && en.boundingClientRect.top < 0; });
        update();
      }).observe(trigger);
    }
    if (shop) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen.shop = en.isIntersecting; });
        update();
      }, { rootMargin: '0px 0px -35% 0px' }).observe(shop);
    }
    if (footer) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen.footer = en.isIntersecting; });
        update();
      }).observe(footer);
    }
  }

  function boot() {
    qsa(document, '[data-cfs-card]').forEach(initCard);
    qsa(document, '[data-cfs-subx]').forEach(initTabs);
    initSticky();
  }

  document.addEventListener('click', onChoose);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
